import React from "react";

import { Lazy } from "../../component/Lazy";
import { ConnectedViewDeviceWithDefaultView as ViewDeviceWithDefaultView } from "../../component/ViewDevice/ConnectedViewDeviceWithDefaultView";
import { UnifiedDeviceViewProps } from "../../component/ViewDevice/UnifiedDeviceViewProps";
import { matchOneOf } from "../MultiRoute";
import { path } from "../path";
import { DefaultRoute, RestrictedRoute } from "../RouteHelpers";
import { mode, uuid } from "../routeParameters";

const CreateDevice = Lazy(
    async () => (await import("../../component/CreateDevice")).CreateDevice,
    { displayName: "CreateDevice" },
);

const UnifiedDeviceView = Lazy(
    async () =>
        (await import("../../component/ViewDevice/UnifiedDeviceView"))
            .UnifiedDeviceView,
    {
        displayName: "UnifiedDeviceView",
    },
);

export const deviceRoutes = {
    createDevice: RestrictedRoute(
        "/create-device",
        () => {
            return <CreateDevice />;
        },
        "devices",
        "administrator",
    ),
    device: DefaultRoute<{ id: string }>(
        path`/devices/${uuid(":id")}`,
        ({ id }) => <ViewDeviceWithDefaultView key={id} id={id} />,
    ),
    unifiedDevice: DefaultRoute<UnifiedDeviceViewProps>(
        matchOneOf({
            views: path`/devices/${uuid(":id")}/${mode("views")}/${uuid(
                ":viewId",
            )}`,
            events: path`/devices/${uuid(":id")}/${mode("events")}`,
            schedules: path`/devices/${uuid(":id")}/${mode("schedules")}`,
        }),
        (props: UnifiedDeviceViewProps) => (
            <UnifiedDeviceView key={props.id} {...props} />
        ),
    ),
} as const;
